var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetaDir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "15px",
    viewBox: "0 0 8 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "seta_dir") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.595923364
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Mobile_Claro",
    transform: "translate(-59.000000, -592.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 1.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "mn-copy-3",
    transform: "translate(-1.000000, 341.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34-Copy-4",
    transform: "translate(20.000000, 227.000635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,29 L45.0606058,33.5931667 C44.4772724,34.1356112 43.5227276,34.1356112 42.9393942,33.5931667 L38,29",
    id: "seta_dir",
    transform: "translate(44.000000, 31.500000) scale(-1, 1) rotate(-270.000000) translate(-44.000000, -31.500000) "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaDir);
export default __webpack_public_path__ + "static/media/seta_dir.94c5e6bd8843cf547eb5feae401c0fc0.svg";
export { ForwardRef as ReactComponent };